import * as tslib_1 from "tslib";
import toggleMessageOptionCheckbox from '../actions/toggleMessageOptionCheckbox';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { OptionsCheckbox } from 'owa-options-controls';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var MessageOptionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessageOptionsFull, _super);
    function MessageOptionsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onEmptyDeletedItemsOnLogOutChange = function (ev, checked) {
            toggleMessageOptionCheckbox('emptyDeletedItemsOnLogOut', checked);
        };
        return _this;
    }
    MessageOptionsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var emptyDeletedItemsOnLogOut = getFallbackValueIfNull(optionStore.emptyDeletedItemsOnLogOut, userOptions.EmptyDeletedItemsOnLogoff);
        return (React.createElement("div", null,
            React.createElement(Label, null, strings.option_mail_LogOutTitle),
            React.createElement(OptionsCheckbox, { checked: emptyDeletedItemsOnLogOut, label: strings.option_mail_EmptyDeletedOnLogOut, onChange: this.onEmptyDeletedItemsOnLogOutChange })));
    };
    MessageOptionsFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], MessageOptionsFull);
    return MessageOptionsFull;
}(React.Component));
export default MessageOptionsFull;
//# sourceMappingURL=MessageOptionsFull.js.map